import {
    api_getMessages,
    api_postMessage,
    api_getMessagesCount,
    api_getChannel,
    api_geChatId,
    api_getAmazonUrl,
    api_updateTyping,
    api_sendPushNotification
} from "./chat.api";
import {api_getUserProfile} from "../userProfile/userProfile.api";
import {
    setChannel,
    clearAllMessages,
    addNewMessage,
    setMessages,
    setMessagesCount,
    getNewMessageReducer,
    setError,
    setFinishedError,
    setInterlocutor,
    deleteInterlocutor,
    setChatData
} from "./chat.reducers";
import API from "../../helpers/apiHelpers";

export const getChat = params => dispatch => (
    api_geChatId(params)
        .then(res => dispatch(setChannel(res)))
        .catch(error => {
            dispatch(setError(error));
        })
);

export const getChannel = params => dispatch => (
    api_getChannel(params).then(res => dispatch(setChannel(res)))
);

export const getInter = params => dispatch => (
    api_getUserProfile(params).then(res => dispatch(setInterlocutor(res[0])))
);
export const deleteInter = () => dispatch => (
    dispatch(deleteInterlocutor())
);
export const setChat = params => dispatch => (
    dispatch(setChatData(params))
);
export const getMessagesCount = params => dispatch => (
    api_getMessagesCount(params).then(res => dispatch(setMessagesCount(res)))
);

export const getMessages = params => dispatch => (
    api_getMessages(params).then(res => dispatch(setMessages(res)))
);

export const setMessage = params => dispatch => (
    api_postMessage(params)
        .then(res => dispatch(getNewMessageReducer()))
        .catch(error => {
            dispatch(setError(error));
            if (error && error.code === 403) {
                dispatch(setFinishedError(error));
            }
        })
);

export const uploadImage = params => dispatch => (
    api_getAmazonUrl(params)
        .then(res => API.uploadToAWS(res?.uploadUrl, params?.file)
            .then(() => dispatch(setMessage({
                chatId: params.chatId,
                body: {
                    ...params?.body,
                    message: `[img]${res.downloadUrl}[/img]`
                }
            })))
        )
);

export const updateTypeIndicator = params => dispatch => (
    api_updateTyping(params).then(res => dispatch(getNewMessageReducer()))
);

export const sendPushNotification = params => dispatch => (
    api_sendPushNotification(params)
);

export const setExternalMessage = params => dispatch => (
    dispatch(addNewMessage(params))
);

export const clearMessages = () => dispatch => (
    dispatch(clearAllMessages())
);
